import _styled, { default as _styled2 } from "styled-components";
import { m } from "framer-motion";
import { useDeepDiveGallery } from "~/features/blocks/inventory/deep-dive-gallery/context";
export function DeepDiveGalleryControlProgress() {
  const {
    autoPlayStatus,
    isVideoPlaying
  } = useDeepDiveGallery();
  if (autoPlayStatus !== "playing" || isVideoPlaying) {
    return null;
  }
  return <_StyledMDiv initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }}>
      <_StyledDiv style={{
      transform: "scaleX(var(--autoplay-progress))"
    }} />
    </_StyledMDiv>;
}
var _StyledMDiv = _styled(m.div).withConfig({
  componentId: "sc-sf-u2kbiu-0"
})({
  "position": "absolute",
  "inset": "0"
});
var _StyledDiv = /*#__PURE__*/_styled2("div").withConfig({
  displayName: "deep-dive-gallery-control-progress___StyledDiv",
  componentId: "sc-enyi9a-0"
})({
  "height": "100%",
  "width": "100%",
  "transformOrigin": "left",
  "--tw-scale-x": "0",
  "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))",
  "backgroundColor": "rgb(75 46 248 / 0.4)"
});